import type { ShurContract } from 'shur-api'

export function isValidShurContract(shurContract: ShurContract | null) {
  return (
    shurContract?.productType && shurContract?.productSubType && shurContract?.productName
  )
}
